import React, { ChangeEventHandler, KeyboardEventHandler } from 'react';

import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { InputOption, ValueContainer } from 'components/common/MyCustomSelect/myCustomSelect';
import SwitchComponent from 'components/common/Switch/Switch';
import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';

import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { MyCustomSelect } from 'components/common';
import classes from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers.module.scss';
import {
    morefilterItems,
    statusOptions,
} from 'components/widgets/FinishDateFuturePotentialDelayDrivers/components/FinishDateFuturePotentialDelayDrivers.utils';

interface Props {
    handleOnSearch: (value: string) => void;
    dateFilter: ISelectOption<string> | null;
    handleDateFilter: (value: ISelectOption<string> | null) => void;
    months: ISelectOption<string>[];
    handleStatus: (value: readonly ISelectOption<string>[]) => void;
    handleStatusType: (value: readonly ISelectOption<string>[]) => void;
    statusFilter: readonly ISelectOption<string>[];
    typeFilter: readonly ISelectOption<string>[];
    handleCriticalPath: ChangeEventHandler<HTMLInputElement>;
    isCriticalPath: boolean;
    handleDelayDriver: ChangeEventHandler<HTMLInputElement>;
    isDelayDriver: boolean;
}

export const CriticalAnalysisDelayDriversFilter = ({
    handleOnSearch,
    dateFilter,
    handleDateFilter,
    months,
    handleStatusType,
    statusFilter,
    handleStatus,
    typeFilter,
    handleCriticalPath,
    isCriticalPath,
    handleDelayDriver,
    isDelayDriver,
}: Props) => {
    const linkToCriticalityRisk = () => {
        return AppRoutes.buildPath(AppRoutes.DASHBOARD_PROJECT_PATH, projectConfig.criticalityAnalysis.link);
    };

    const [search, setSearch] = React.useState('');

    const handleClearSearch = () => {
        setSearch('');
        handleOnSearch('');
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch(search);
        }
    };

    const handleClick = () => {
        handleOnSearch(search);
    };

    return (
        <div className={classes.filtersAndLinkContainer}>
            <div className={classes.filterWrapper}>
                <div className={classes.title}>Name</div>
                <div className={classes.filterTextSearch}>
                    <TextSearchInput
                        placeholder="Search Activities by Name"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        handleClear={handleClearSearch}
                        maxLength={200}
                        handleClick={handleClick}
                        onKeyDown={onKeyDown}
                        className={classes.textInput}
                    />
                </div>

                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Month</div>
                    <MyCustomSelect<ISelectOption<string>>
                        value={dateFilter}
                        options={months}
                        onChange={handleDateFilter}
                    />
                </div>
                <div className={classes.selectWrapper}>
                    <div className={classes.title}>Status</div>
                    <MyCustomSelect<ISelectOption<string>, true>
                        id={'status-filter'}
                        value={statusFilter}
                        options={statusOptions}
                        onChange={handleStatusType}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select Status...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
                <div>
                    Delay Driver
                    <SwitchComponent onChange={handleDelayDriver} checked={isDelayDriver} />
                </div>
                <div>
                    Critical Path Only
                    <SwitchComponent onChange={handleCriticalPath} checked={isCriticalPath} />
                </div>
                <div className={classes.selectWrapper}>
                    <div className={classes.title}>More Filters</div>
                    <MyCustomSelect<ISelectOption<string>, true>
                        value={typeFilter}
                        options={morefilterItems}
                        onChange={handleStatus}
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        isMulti={true}
                        placeholder={'Select More Filters...'}
                        components={{
                            Option: InputOption,
                            ValueContainer: ValueContainer,
                        }}
                    />
                </div>
            </div>
            <div className={classes.linkContainer}>
                <Link to={linkToCriticalityRisk()}>View in {projectConfig.criticalityAnalysis.title}</Link>
            </div>
        </div>
    );
};
